import { render, staticRenderFns } from "./ParameterSelectbox.vue?vue&type=template&id=45820e11&"
import script from "./ParameterSelectbox.vue?vue&type=script&lang=js&"
export * from "./ParameterSelectbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports